import ApiClient from './api'

const fetch = (mockData, time = 0) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(mockData)
    }, time)
  })
}

function handleFile(blob, fileName, type, mime) {
  // It is necessary to create a new blob object with mime-type explicitly set
  // otherwise only Chrome works like it should
  const newBlob = new Blob([blob], { type: mime })

  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob)
    return
  }

  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(newBlob)
  const link = document.createElement('a')
  link.href = data
  link.download=`${fileName}.${type}`
  link.click()

  setTimeout(function() {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data)
  }, 100)
}

export default {
  // Авторизация
  register(credentials) {
    return ApiClient.post('/register', credentials)
  },
  login(credentials) {
    return ApiClient.post('/auth', credentials)
  },
  activateAccount(token) {
    return ApiClient.post('/activateAccount', token)
  },
  resetPassword(email) {
    return ApiClient.post('/resetPassword', email)
  },
  // Общая информация
  getAccInfo() {
    return ApiClient.get('/getAccInfo')
  },
  // Ссылки доступа к 1С
  getAccessLinks() {
    return ApiClient.get('/getAccessLinks')
  },
  // Тарифы
  activatePlan(id) {
    return ApiClient.post('/activatePlan', { id })
  },
  getPlans() {
    return ApiClient.get('/getPlans')
  },
  // Услуги
  deactivateServices(servicesIDs) {
    return ApiClient.post('/deactivateServices', servicesIDs)
  },
  // Пользователи
  getUsers() {
    return ApiClient.get('/getUsers')
  },
  createUser(userData) {
    return ApiClient.post('/createUser', userData)
  },
  editUser(userData) {
    return ApiClient.post('/editUser', userData)
  },
  deleteUser(id) {
    return ApiClient.post('/deleteUser', { id })
  },
  // Дополнительные опции
  getDiskSpaceInfo() {
    return ApiClient.get('/getDiskSpaceInfo')
  },
  changeDiskSpace(change) {
    return ApiClient.post('/changeDiskSpace', { change })
  },
  getActivatedServices() {
    return ApiClient.get('/getActivatedServices')
  },
  requestServiceActivation(message) {
    return ApiClient.post('/requestServiceActivation', { message })
  },
  // Счета
  getBills() {
    return ApiClient.get('/getBills')
  },
  deleteBill(id) {
    return ApiClient.post('/deleteBill', { id })
  },
  getAvailableBills() {
    return ApiClient.get('/getAvailableBills')
  },
  makeBill(id) {
    return ApiClient.post('/makeBill', { id })
  },
  // Платежи
  getPayments() {
    return ApiClient.get('/getPayments')
  },
  // Реквизиты
  getRequisites() {
    return ApiClient.get('/getRequisites')
  },
  getRequisiteFormData() {
    return ApiClient.get('/getRequisiteFormData')
  },
  createRequisite(data) {
    return ApiClient.post('/createRequisite', data)
  },
  editRequisite(data) {
    return ApiClient.post('/editRequisite', data)
  },
  // Инструкции
  getInstructions(categoryId) {
    return categoryId
        ? ApiClient.post('/getInstructionsList', { categoryId })
        : ApiClient.post('/getInstructionsList')
  },
  getInstructionById(instructionId) {
    return ApiClient.post('/getInstructionById', { instructionId })
  },
  getRoutes() {
    return ApiClient.get('/getDynamicRoutes')
  },
  getRoutesTree() {
    return fetch(instructions, 1000)
  },
  // Базы данных
  getDatabases() {
    return ApiClient.get('/getDatabases')
  },
  getDatabasesToCreate() {
    return ApiClient.get('/getDatabasesToCreate')
  },
  createDatabases(databasesIDs) {
    return ApiClient.post('/createDatabases', databasesIDs)
  },
  addDatabasesToUsers(data) {
    return ApiClient.post('/addDatabasesToUsers', data)
  },
  transferDatabases(data) {
    return ApiClient.post('/transferDatabases', data)
  },
  publishDatabase(databaseId) {
    return ApiClient.post('/publishDatabase', databaseId)
  },
  unpublishDatabase(databaseId) {
    return ApiClient.post('/unpublishDatabase', databaseId)
  },
  getDatabasesToBackup() {
    return ApiClient.get('/getDatabasesToBackup')
  },
  makeDatabaseBackup(data) {
    return ApiClient.post('/makeDatabaseBackup', data)
  },
  // Техподдержка
  getSupportRequests() {
    return ApiClient.get('/getSupportRequests')
  },
  createSupportRequest(data) {
    return ApiClient.post('/createSupportRequest', data)
  },
  getUnreadedSupportAnswers() {
    return ApiClient.get('/getUnreadedSupportAnswers')
  },
  getSupportRequestChat(params) {
    return ApiClient.get('/getSupportRequestChat', { params })
  },
  readSupportChat(data) {
    return ApiClient.post('/readSupportChat', data)
  },
  sendSupportChatMessage(data) {
    return ApiClient.post('/sendSupportChatMessage', data)
  },
  // Общее
  async getFile(method, { fileName, params={}, type='pdf' }) {
    const typeToMime = {
      pdf: 'application/pdf',
      rdp: 'application/x-rdp'
    }

    const mime = typeToMime[type]

    const { data } = await ApiClient.get(
      `/${method}`,
      {
        params,
        headers: { 'content-type': mime },
        responseType: 'blob'
      }
    )

    handleFile(data, fileName, type, mime)
  }
}